import { Injectable } from "@angular/core";
import { Http, RequestOptions, Headers } from "@angular/http";
import "rxjs/add/operator/map";
import { ConfigurationService } from "ionic-configuration-service";
import { Storage } from "@ionic/storage";
import { NavController } from "ionic-angular";
import { CollectionPointPage } from "../../pages/backoffice/collecion-points";
import { SummaryServiceProvider } from "../wh/summary-service";
import { AuthService } from "../auth-service";

/*
  Generated class for the WaybillOrderServiceProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class WaybillOrderServiceProvider {
  public data: any;

  constructor(
    private nav: NavController,
    private configurationService: ConfigurationService,
    public http: Http,
    private storage: Storage,
    private auth: AuthService,
    public summaryService: SummaryServiceProvider
  ) {}

  search(pram) {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers });
        let userInfo = JSON.parse(localStorage.getItem("userInfoData"));
        // let userInfo: any = localStorage.getItem("userInfoData");

        let qs = "";
        if (userInfo) {
          if (userInfo.currency) {
            qs += `&currencyCode=${userInfo.currency}`;
          }
        }
        /// HERE WE WILL CALL FUZZY SEARCH TO GET ANY  INFORMATION QUICKLY
        let url =
          this.configurationService.getValue<string>("API_ENDPOINT") +
          "api/v0.2/fuzzySearch?q=" +
          pram +
          qs;
        this.http
          .get(url, options)
          .map(res => res.json())
          .subscribe(
            data => {
              if (data.data.length == 0) {
                var q = "siteId=" + pram;
                this.summaryService.load_cp_data(q).then((res: any) => {
                  if (res.data.content.length == 1) {
                    this.nav.setRoot(CollectionPointPage, { site_id: pram });
                  } else {
                    resolve(data);
                  }
                });
              } else if (data.data.length > 0) {
                let orderNo = data.data[0].orderNo;

                let url =
                  this.configurationService.getValue<string>("API_ENDPOINT") +
                  "api/v0.2/backoffice/shipments/" +
                  orderNo;
                this.http
                  .get(url, options)
                  .map(res => res.json())
                  .subscribe(data => {
                    resolve(data);
                  });
              } else {
                resolve(data);
              }
            },
            error => {
              console.log(error);
              resolve(error);
            }
          );
      });
    });
  }

  get_dashboard_data(start_date, end_date) {
    /*if (this.data) {
      // already loaded data
      return Promise.resolve(this.data);
    }*/

    // don't have the data yet
    return new Promise(resolve => {
      this.http
        .get(
          this.configurationService.getValue<string>("CLIENTPORTAL_ENDPOINT") +
            "stats/alist_json?e_id=1&start_date=" +
            start_date +
            "&end_date=" +
            end_date
        )
        .map(res => res.json())
        .subscribe(data => {
          resolve(data);
        });
    });
  }

  get_driver_dashboard_data(start_date, end_date, driver_id, e_id) {
    // don't have the data yet
    return new Promise(resolve => {
      ///resolve({"driver_info":{"4201601120624288819":{"name":"Mohsin"}},"total":{"4201601120624288819":{"day_of_the_month":"23 Days","number_of_created_parcels":759,"number_of_not_picked_up_by_driver":1,"number_of_picked_up_from_retailer":754,"number_of_still_in_transit":39,"number_of_received_at_collection_point":715,"number_of_not_picked_up_by_customer":467,"number_of_collected_by_customer":248,"number_of_ready_for_return":272,"rto_intransit_to_client":31,"rto_delivered_to_client":0,"orders_cancelled":4}},"invoices":{"4201601120624283439":{"uncollected":"2.0000","collected":"11.0000"},"4201601120624288819":{"uncollected":"1759.0000","collected":"526.0000"}}})
      this.http
        .get(
          this.configurationService.getValue<string>("CLIENTPORTAL_ENDPOINT") +
            "stats/alist_details_driver_json?start_date=" +
            start_date +
            "&end_date=" +
            end_date +
            "&driver_id=" +
            driver_id +
            "&e_id=" +
            e_id +
            "&is_test=" +
            this.configurationService.getValue<string>("IS_TEST")
        )
        .map(res => res.json())
        .subscribe(data => {
          console.log(data);
          resolve(data);
        });
    });
  }

  patchCPStatusChange(endpoint, data) {
    // don't have the data yet
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers });
        let url =
          this.configurationService.getValue<string>("API_ENDPOINT") + endpoint;
        this.http
          .patch(url, data, options)
          .map(res => res.json())
          .subscribe(data => {
            resolve(data);
          });
      });
    });
  }

  getClearRedis(endpoint) {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers });
        let url =
          this.configurationService.getValue<string>("API_ENDPOINT") + endpoint;
        this.http
          .get(url, options)
          .map(res => res.json())
          .subscribe(data => {
            resolve(data);
          });
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/qdb/qdb-service.ts